module.exports = __webpack_public_path__ + "img/letter_icon1.c0242fe8.png";